import { URL_API } from 'src/configs/keys'
import baseActions from 'src/helpers/redux/baseActions'

const master = 'financing-partner'
const type = 'haji'

export const actionType = (action) => {
  return {
    request: `${action}_${type}_request`.toUpperCase(),
    success: `${action}_${type}_success`.toUpperCase(),
    error: `${action}_${type}_error`.toUpperCase(),
  }
}

export default {
  ...baseActions(master, URL_API, actionType),
}
